import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data';

import { Appointment } from '@work4all/models/lib/Classes/Appointment.entity';
import { User } from '@work4all/models/lib/Classes/User.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const useAppointmentsSummary = ({ users }: { users: User[] }) => {
  const request = useMemo(() => {
    const today = DateTime.now();

    // adding a millisecond to avoid catching whole-day appointments from the day before
    const startDate = today.startOf('day').plus({ millisecond: 1 });
    const endDate = startDate.endOf('day');

    const startDateJson = startDate.toISO();
    const endDateJson = endDate.toISO();

    const dataRequest: DataRequest = {
      operationName: 'GetAppointmentsSummaryForCalendar',
      entity: Entities.appointment,
      data: {
        id: null,
      } as Appointment<EMode.query>,
      filter: [
        { startDate: { $lt: endDateJson } },
        { endDate: { $gte: startDateJson } },
        {
          userId: {
            $in: users.length > 0 ? users.map((user) => user.id) : [-1],
          },
        },
      ].filter(Boolean),
    };

    return dataRequest;
  }, [users]);

  const response = useDataProvider<Appointment>(request, false, 9999);

  const { data } = response;

  return data;
};
